module.exports = __webpack_public_path__ + "static/media/fl-cover.2625ae1a.png";